import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useApi from "../../hook/useApi";
import Paggination from "../Paggination";
import Loader from "../Loader/Loader";
import {
  copyToClipboard,
  formatDateInAMPM,
  trimAddress,
} from "../../utils/helper";
import { IoCopyOutline } from "react-icons/io5";
import { AIRDROP_STATUS } from "../../utils/constant";
import UpdatePriceModal from "../model/UpdateIcoPrice";
import SetICOTimeModal from "../model/SetICOTimeModal";
import AddFiatPurchaseModal from "../model/AddFiatPurchaseModal";
import WithdrawModal from "../model/WithdrawModal";

const IcoTransactionsLayer = () => {
  const { AsyncGetApiCall } = useApi();
  const navigate = useNavigate();
  const [query, setQuery] = useState({
    pageNo: 1,
    limitVal: 50,
    search: "",
    status: "",
  });
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [currentTask, setCurrentTask] = useState(null);

  const [showSetTime, setShowSetTime] = useState(false);
  const [showAddFiat, setShowAddFiat] = useState(false);
  const [showWithdraw, setShowWithdraw] = useState(false);

  const { AsyncPostApiCall } = useApi();

  const handlePriceUpdated = async (updatedData) => {
    try {
      // Close modal
      setShowModal(false);

      // Refresh ICO list
      await getAllIcoList();

      // Trigger notification API
      const notifyRes = await AsyncPostApiCall("/notifications/admin", {
        title: "Admin updated ICO Token Price",
        description: `The ICO token price has been updated to ${updatedData?.newPrice || "a new value"
          }.`,
        isAdmin: true,
      });

      if (notifyRes?.success) {
        //    toast.success("Notification sent successfully");
      } else {
        toast.error(notifyRes?.message || "Failed to send notification");
      }
    } catch (error) {
      console.log("Error in handlePriceUpdated:", error);
      toast.error("Something went wrong while sending notification");
    }
  };

  const setPageNo = (pageNo) => {
    setQuery((prev) => ({
      ...prev,
      pageNo: pageNo,
    }));
  };

  const getAllIcoList = async (showLoader = true) => {
    try {
      if (showLoader) setLoading(true);

      // Build query object to match backend
      const params = {
        pageNo: query.pageNo,
        limitVal: query.limitVal,
        ...(query.buyerWalletAddress && {
          buyerWalletAddress: query.buyerWalletAddress,
        }),
        ...(query.status && { status: query.status }),
      };

      const result = await AsyncGetApiCall("/private-sale/list", params);

      if (result?.success) {
        setData(result || []);
      } else {
        toast.error(result?.message || "Failed to fetch airdrop data");
      }
    } catch (error) {
      console.log("error...", error);
    } finally {
      if (showLoader) setLoading(false);
    }
  };

  const handleSearchAirdrop = (e) => {
    const value = e.target.value;
    const validChars = /^[a-zA-Z0-9]*$/; // Only alphanumeric characters allowed

    // if (validChars.test(value)) {
    //      setQuery((prev) => ({ ...prev, search: value, pageNo: 1 }));
    // }

    if (validChars.test(value)) {
      setQuery((prev) => ({
        ...prev,
        buyerWalletAddress: value, // map to backend param
        pageNo: 1,
      }));
    }
  };

  // Prevent form submission
  const handleFormSubmit = (e) => {
    e.preventDefault();
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setQuery((prev) => ({
      ...prev,
      status: value === "Select Status" ? "" : value,
      pageNo: 1,
    }));
  };

  useEffect(() => {
    getAllIcoList(false);
  }, [query]);

  const handleSaveTask = () => {
    console.log("abc");
  };

  return (
    <>
      {loading && <Loader />}
      <div className="card h-100 p-0 radius-12">
        <div className="d-flex flex-wrap align-items-center gap-2 py-3 mt-3 mb-4 px-3 -3 border-bottom bg-base">
          <button
            className="btn btn-primary d-flex align-items-center gap-2"
            onClick={() => setShowModal(true)}
          >
            Update Token Price
          </button>
          <button
            className="btn btn-secondary d-flex align-items-center gap-2"
            onClick={() => setShowSetTime(true)}
          >
            Set ICO Time
          </button>
          <button
            className="btn btn-success d-flex align-items-center gap-2"
            onClick={() => setShowAddFiat(true)}
          >
            Add Fiat Purchase
          </button>
          <button
            className="btn btn-warning d-flex align-items-center gap-2"
            onClick={() => setShowWithdraw(true)}
          >
            Withdraw
          </button>
        </div>

        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex justify-content-between w-100">
            <div className="d-flex align-items-center flex-wrap gap-3">
              <span className="text-md fw-medium text-secondary-light mb-0">
                Show
              </span>
              <select
                className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                value={query.limitVal}
                onChange={(e) => {
                  const value = parseInt(e.target.value, 10);
                  setQuery((prev) => ({
                    ...prev,
                    limitVal: value,
                    pageNo: 1,
                  }));
                }}
              >
                {Array.from({ length: 20 }, (_, i) => {
                  const value = (i + 1) * 5;
                  return (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  );
                })}
              </select>
              <form className="navbar-search" onSubmit={handleFormSubmit}>
                <input
                  type="text"
                  className="bg-base h-40-px w-auto"
                  name="search"
                  placeholder="Search"
                  onChange={handleSearchAirdrop}
                  // value={query.search}
                  value={query?.buyerWalletAddress || ""}
                />
                <Icon icon="ion:search-outline" className="icon" />
              </form>
              <span className="text-md fw-medium text-secondary-light mb-0">
                Status
              </span>
              <select
                name="status"
                id="status"
                className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                value={query.status || "Select Status"}
                onChange={handleStatusChange}
              >
                <option value="Select Status">Select Status</option>
                <option value={AIRDROP_STATUS.SUCCESS}>Success</option>
                <option value={AIRDROP_STATUS.PENDING}>Pending</option>
                <option value={AIRDROP_STATUS.FAILED}>Failed</option>
              </select>
            </div>
          </div>
        </div>

        <div className="card-body p-24">
          <div className="table-responsive scroll-sm">
            <table className="table bordered-table sm-table mb-0">
              <thead>
                <tr>
                  <th scope="col">
                    <div className="d-flex align-items-center gap-10">
                      <div className="form-check style-check d-flex align-items-center"></div>
                      S.No
                    </div>
                  </th>
                  <th scope="col">Buyer Address</th>
                  <th scope="col">Quantity</th>
                  <th scope="col">Price</th>
                  <th scope="col">Paid Amount</th>
                  <th scope="col">TX Hash</th>
                  <th scope="col">Status</th>
                  <th scope="col">Created At</th>
                  <th scope="col" className="text-center">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.data && data?.data?.length > 0 ? (
                  data?.data?.map((ico, index) => (
                    <tr key={ico._id}>
                      <td>
                        <div className="d-flex justify-content-center align-items-center gap-10">
                          {(data?.currentPage - 1) * query.limitVal + index + 1}
                        </div>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {trimAddress(ico?.buyerWalletAddress, 6, 6)}
                          <button
                            onClick={() =>
                              copyToClipboard(ico?.buyerWalletAddress)
                            }
                            className="ms-3 p-0 border-0 bg-transparent"
                            style={{ lineHeight: 1 }}
                          >
                            <IoCopyOutline />
                          </button>
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {Number(ico?.quantity).toFixed(2) || "N/A"}
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {`${Number(ico?.pricePerToken).toFixed(8)} ETH` || "N/A"}
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {`${ico?.totalAmountPaid} ETH` || "N/A"}
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {trimAddress(ico?.txHash, 6, 6) || "N/A"}
                          {ico?.txHash && (
                            <button
                              onClick={() => copyToClipboard(ico?.txHash)}
                              className="ms-3 p-0 border-0 bg-transparent"
                              style={{ lineHeight: 1 }}
                            >
                              <IoCopyOutline />
                            </button>
                          )}
                        </span>
                      </td>
                      <td>
                        <span
                          className={`badge ${ico?.status === AIRDROP_STATUS.SUCCESS
                            ? "bg-success-100 text-success-600"
                            : ico?.status === AIRDROP_STATUS.PENDING
                              ? "bg-warning-100 text-warning-600"
                              : ico?.status === AIRDROP_STATUS.FAILED
                                ? "bg-danger-100 text-danger-600"
                                : "bg-primary-300 text-secondary-600"
                            } text-sm py-4 px-10 radius-4`}
                        >
                          {ico?.status?.toUpperCase()}
                        </span>
                      </td>
                      <td>
                        <span className="text-md mb-0 fw-normal text-secondary-light">
                          {formatDateInAMPM(ico?.createdAt)}
                        </span>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center gap-10 justify-content-center">
                          <button
                            type="button"
                            className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                            onClick={() => navigate(`/ico-tx-view/${ico?._id}`)}
                          >
                            <Icon
                              icon="majesticons:eye-line"
                              className="icon text-xl"
                            />
                            <span className="tooltip-text">View</span>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No ico transactions found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <Paggination
            total={data?.total || 0}
            totalPages={data?.totalPages || 0}
            currentPage={data?.currentPage || 0}
            setPageNo={setPageNo}
            startFrom={(data?.currentPage - 1) * query.limitVal + 1}
            endTo={
              (data?.currentPage - 1) * query.limitVal + data?.data?.length
            }
          />
        </div>
      </div>
      {showModal && (
        <UpdatePriceModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          onPriceUpdated={handlePriceUpdated}
        />
      )}

      {showSetTime && (
        <SetICOTimeModal
          show={showSetTime}
          handleClose={() => setShowSetTime(false)}
        />
      )}
      {showAddFiat && (
        <AddFiatPurchaseModal
          show={showAddFiat}
          handleClose={() => setShowAddFiat(false)}
        />
      )}
      {showWithdraw && (
        <WithdrawModal
          show={showWithdraw}
          handleClose={() => setShowWithdraw(false)}
        />
      )}
    </>
  );
};

export default IcoTransactionsLayer;
